import { Documents } from 'src/hooks/types';

export const getDocumentIds = (documents: Documents) => {
  return documents?.map(({ id }) => id) || [];
};
